import { App } from "vue";
import VueHotjar from "vue-hotjar-next";
import { ProductVersion } from "@/apps/merchant3/types/ProductVersion";

interface IRecorder {
  startRecording: (app: RECORDING_APPS) => void;
  updateRecordingInfo: (userId: number, data: Record<string, unknown>) => void;
  recordEvent: (event: string) => void;
  isRecording: () => boolean;
}

// Add new apps here
export enum RECORDING_APPS {
  ADMIN_CONSOLE = "ADMIN_CONSOLE",
  CREDIT_LINE = "CREDIT_LINE",
  IDENTITY = "IDENTITY",
  M3 = "M3",
  M3_DIRECT_TO_CUSTOMER = "M3_DIRECT_TO_CUSTOMER",
  M3_ECOMMERCE = "M3_ECOMMERCE",
}

export enum EVENTS {
  ACCEPT_TERMS_AND_CONDITIONS = "accept_terms_and_conditions",
  CART_CANCELLED = "cart_cancelled",
  CART_CANCELLED_SELF_SERVICE = "cart_cancelled_self_service",
  CHECKOUT_ON_SIMULTANEOUS_LOAN_LINE = "checkout_on_simultaneous_loan_line",
  CONFIGURABLE_M3_CART = "configurable_m3_cart",
  ECOMMERCE_AUTHENTICATION = "ecommerce_authentication",
  KYC_REUSE_CART_CANCELLED = "kyc_reuse_person_cancelled",
  KYC_REUSE_CART_CREATED = "kyc_reuse_cart_created",
  TERMINATE_SALE = "terminate_sale",
  TERMS_AND_CONDITIONS_LOADED = "terms_and_conditions_loaded",
}

export const productVersionRecordingAppsMapper = (
  productVersion: string
): RECORDING_APPS => {
  if (productVersion === ProductVersion.M3_ECOMMERCE) {
    return RECORDING_APPS.M3_ECOMMERCE;
  }

  return RECORDING_APPS.M3;
};

let recordingStarted = false;

export const recorder = (vueApp: App | undefined): IRecorder | undefined => {
  if (!vueApp) {
    return;
  }

  const hotJarOptions = {
    id: 3010879,
    isProduction: process.env.NODE_ENV == "production",
    snippetVersion: 6,
  };

  let globalApp = RECORDING_APPS.M3;

  return {
    startRecording: (app: RECORDING_APPS) => {
      if (recordingStarted) {
        return;
      }

      globalApp = app;
      recordingStarted = true;

      vueApp.use(VueHotjar, hotJarOptions);

      if (window["hj"]) {
        window["hj"]("identify", null, { app: globalApp });
      }
    },
    updateRecordingInfo: (userId, data) => {
      if (window["hj"]) {
        window["hj"]("identify", userId, { app: globalApp, ...data });
      }
    },
    recordEvent: (eventName: string): void => {
      if (window["hj"]) {
        window["hj"]("event", eventName);
      }
    },
    isRecording: (): boolean => {
      return recordingStarted;
    },
  };
};
